import { render, staticRenderFns } from "./VTaskTable.vue?vue&type=template&id=5f6461af&"
import script from "./VTaskTable.vue?vue&type=script&lang=js&"
export * from "./VTaskTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports